import { DateTime } from 'luxon'
import { AdyenResultStatus } from './adyenResultStatus.enum'
import { Lot, LotViewName } from './lot.interface'
import { Vehicle } from './vehicle.interface'

export interface Checkout {
    success?: boolean
    lot: Lot | null
    price: number
    start_datetime?: DateTime | string
    end_datetime?: DateTime | string
    duration?: number
    plate?: string
    email?: string
    bookingNo?: string
    paymentStatus?: AdyenResultStatus
    locale?: string
    backUrl?: string
    paymentMethod?: PaymentMethod
    unavailable_dates?: string[]
    selectedVehicles?: Vehicle[]
    lotCheckoutType: LotViewName
}

export enum PaymentMethod {
    CARD = 'card',
    SOFORT = 'directEbanking',
    KLARNA = 'klarna_paynow',
    APPLE_PAY = 'applepay',
    MC_APPLE_PAY = 'mc_applepay',
    VISA_APPLE_PAY = 'visa_applepay',
    AMEX_APPLE_PAY = 'amex_applepay',
    DISCOVER_APPLE_PAY = 'discover_applepay',
    JCB_APPLE_PAY = 'jcb_applepay',
    MAESTRO_APPLE_PAY = 'maestro_applepay',
    ELECTRON_APPLE_PAY = 'electron_applepay',
    GIROCARD_APPLE_PAY = 'girocard_applepay',
    INTERAC_APPLE_PAY = 'interac_applepay',
    GOOGLE_PAY = 'googlepay',
    AMEX_GOOGLE_PAY = 'amex_googlepay',
    DISCOVER_GOOGLE_PAY = 'discover_googlepay',
    MAESTRO_GOOGLE_PAY = 'maestro_googlepay',
    MC_GOOGLE_PAY = 'mc_googlepay',
    VISA_GOOGLE_PAY = 'visa_googlepay',
    INTERAC_GOOGLE_PAY = 'interac_googlepay',
    SEPADIRECTDEBIT = 'sepadirectdebit'
}
